const DailyLogs = {

    // FIELDS
    "farm": "Farm",
    "room": "Room",
    "crop": "Crop",
    "date": "Date",

    "temp": "Temperature (°C)",
    "humidity": "Humidity (%)",
    "vpd": "VPD (kPa)",
    "lux": "Light Intensity (Lux/PAR)",

    "harvest_handling": 'Harvest Handling Notes',
    "washing_packing": 'Washing / Packing Done?',
    "batch_segregation": 'Batch Segregation Details',

    "nutrient_scheduling": 'Nutrient Scheduling',
    "nutrient_quantity": 'Nutrient Quantity',
    "chemical_scheduling": 'Chemical Scheduling',
    "chemical_quantity": 'Chemical Quantity',
    "ec": 'EC Value',
    "ph": 'pH Value',

    "ipm_pesticide": 'IPM / Pesticide Records',
    "time_of_app": 'Time of Application',
    "dosage_used": 'Dosage Used',
    "phi_tracking": 'PHI Tracking (days)',

    "pest_disease": 'Disease',
    "upload": 'Upload Photos',
    "severity": 'Severity',
    "corrective_actions": 'Corrective Actions Taken',

    "quantity": 'Quantity (kg)',
    "quality_a": 'Quality Grading A',
    "quality_b": 'Quality Grading B',
    "quality_c": 'Quality Grading C',
    "harvesting_image_one": 'Harvesting Image One',
    "harvesting_image_two": 'Harvesting Image Two',

    "weight_dispatched": 'Total Weight Dispatched (kg)',
    "rejections": 'Rejections (kg)',
    "delivery_notes": 'Delivery Notes',

    // PAGE HEADER
    "daily_logs": "Daily Logs",
    "add_daily_log": "Add Daily Log",
    "logs": "Logs",
    "search": "Search",
    "from_date": "From Date",
    "to_date": "To Date",

    // TABLE
    "table_farm": "FARM",
    "table_room": "ROOM",
    "table_crop": "CROP",
    "table_supervisor": "SUPERVISOR",
    "table_harvest_qty": "HARVEST (KG)",
    "table_status": "STATUS",

    "details_title": "Daily Log Details",
    "back_to_list": "Back to list",
    "supervisor": "Supervisor",
    "location_map": "Location Map",
    "daily_log_location": "Daily log location",
    "farm_location": "Farm location",
    "map_load_error": "Unable to load interactive map. Showing static map if available.",
    "map_key_missing": "Google Maps API key is missing.",
    "map_latitude": "Latitude",
    "map_longitude": "Longitude",
    "map_locality": "Locality / Address",
    "map_loading_locality": "Loading locality…",
    "map_locality_unavailable": "Locality not available",
    "section_environment": "Environment",
    "section_post_harvest": "Post Harvest",
    "section_fertigation": "Fertigation",
    "section_spray": "Spray / IPM",
    "section_scouting": "Scouting",
    "section_harvest": "Harvest",
    "section_dispatch": "Dispatch",
    "section_nutrients": "Nutrients",
    "section_chemicals": "Chemicals",
    "preventive": "Preventive",
    "sightings": "Sightings",
    "scouting_photos": "Scouting Photos",
    "not_found": "Daily log details not found",
    "nutrient_name": "Nutrient",
    "chemical_name": "Chemical",
    "volume": "Volume",
    "quantity_used": "Quantity",
    "created_at": "Created At",
    "updated_at": "Updated At",

    // ERROR
    "error_farm": "Select Farm",
    "error_room": "Select Room",
    "error_crop": "Select Crop",
    "error_date": "Choose Date",

    "error_temp": "Enter Temperature",
    "error_humidity": "Enter Humidity",
    "error_vpd": "Enter VPD",
    "error_lux": "Enter Light Intensity",

    "error_harvest_handling": 'Enter Harvest Handling Notes',
    "error_washing_packing": 'Select Washing / Packing Done?',
    "error_batch_segregation": 'Enter Batch Segregation Details',

    "error_nutrient_scheduling": 'Enter Nutrient Scheduling',
    "error_volume": 'Enter Volume Used',
    "error_ec": 'Enter EC Value',
    "error_ph": 'Enter pH Value',

    "error_ipm_pesticide": 'Enter IPM / Pesticide Records',
    "error_time_of_app": 'Choose Time of Application',
    "error_dosage_used": 'Enter Dosage Used',
    "error_phi_tracking": 'Enter PHI Tracking',

    "error_pest_disease": 'Enter Pest / Disease Sightings',
    "error_upload": 'Choose Photos',
    "error_severity": 'Select Severity',
    "error_corrective_actions": 'Enter Corrective Actions Taken',

    "error_quantity": 'Enter Quantity',
    "error_quality_a": 'Enter Quality Grading A',
    "error_quality_b": 'Enter Quality Grading B',
    "error_quality_c": 'Enter Quality Grading C',

    "error_weight_dispatched": 'Enter Total Weight Dispatched',
    "error_rejections": 'Enter Rejections',
    "error_delivery_notes": 'Enter Delivery Notes',
}

export default DailyLogs;